import { ArrowBack, CopyAllOutlined } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  Button,
  CheckboxGroupInput,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
import React from "react";

import formatPhone from "../../unit/inputFormat/formatPhone";
import parsePhone from "../../unit/inputFormat/parsePhone";
import EditIcon from "../../unit/svgIcon/EditIcon";
const EditToolbar = (props: any) => {
  const { reset } = useFormContext();
  const { success, error, info } = useNotify();
  const { getValues, formState } = useFormContext();
  const isDirty = formState.isDirty;

  const record = useRecordContext();
  const id = record?.id;
  const handleUndo = () => {
    reset();
    //set isDirty to false
    success("Changes have been cancel");
  };

  const saveData = () => {
    const reqUrl = "banks/actions/edit";

    const formData = isDirty ? getValues() : null;
    if (formData) {
      const saveFormData = {
        esign_firstname: formData.esign_firstname,
        esign_lastname: formData.esign_lastname,
        esign_email: formData.esign_email,
        saveType: "esign",
      };
      if (!saveFormData?.esign_firstname) {
        error("E-Signature Sender First Name is required");
        return;
      }
      if (!saveFormData?.esign_lastname) {
        error("E-Signature Sender Last Name is required");
        return;
      }
      if (!saveFormData?.esign_email) {
        error("E-Signature Sender Email is required");
        return;
      }
      sendRequest(reqUrl, { id: id, data: saveFormData }).then((res) => {
        if (res?.code == 200) {
          success("Saved successfully");
          reset(formData);
        } else {
          error("Error saving " + res?.message);
        }
      });
    } else {
      error("Error saving description: No data to save");
    }
  };
  return (
    <Box
      sx={{
        display: "block",
        mt: "2px",
        borderRadius: "0px",
        paddingTop: "0px",
      }}
    >
      <Toolbar
        {...props}
        sx={{
          background: "#fff",
          justifyContent: "space-between",
          // border: "1px solid red",
          borderTop: "1px solid #e0e0e0",
          padding: "0px",
          marginTop: "10px",
          "&.MuiToolbar-root.RaToolbar-root": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
        }}
      >
        <CustomButtonCancel label="Undo" onClick={handleUndo} />
        {/* <SaveButton /> */}
        <CustomButtonSave
          variant="contained"
          color="primary"
          onClick={saveData}
          disabled={!isDirty}
          sx={{
            width: "120px",
          }}
        />
      </Toolbar>
    </Box>
  );
};

const ShowEsignChangeEmailMessage = () => {
  const record = useRecordContext();
  if (record?.sNewEmail && record?.sNewEmail != record?.esign_email) {
    return (
      <Typography variant="caption" color="error">
        Email has been changed to{" "}
        <span style={{ fontWeight: "bold" }}>{record?.sNewEmail}</span>, waiting
        for confirmation.
      </Typography>
    );
  }
};
const EsignEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();
  const [editEsignEmail, setEditEsignEmail] = React.useState(false);
  if (!record) return <div>Loading...</div>;

  return (
    <SimpleForm toolbar={<EditToolbar />}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        {/*esign_firstname  */}
        <HmTextInput
          source="esign_firstname"
          label="E-Signature Sender First Name"
          validate={[required()]}
          readOnly={isEdit ? false : true}
        />
        {/*esign_lastname */}
        <HmTextInput
          source="esign_lastname"
          label="E-Signature Sender Last Name"
          validate={[required()]}
          readOnly={isEdit ? false : true}
        />
        {/* esign_email */}
        <HmTextInput
          source="esign_email"
          label="E-Signature Sender Email"
          validate={[required()]}
          readOnly={isEdit ? false : true}
          // sx={{
          //   width: "100%",
          //   "& input.Mui-readOnly": {
          //     backgroundColor: "#ddd",
          //     borderRadius: "10px",
          //   },
          // }}
          // InputProps={{
          //   readOnly: editEsignEmail ? false : true,
          //   endAdornment: (
          //     <InputAdornment position="end">
          //       {editEsignEmail ? (
          //         <></>
          //       ) : (
          //         <IconButton
          //           aria-label={"Change E-Signature Email"}
          //           onClick={() => setEditEsignEmail(true)}
          //           edge="end"
          //           sx={{ marginLeft: "0px" }}
          //         >
          //           <EditIcon />
          //         </IconButton>
          //       )}
          //     </InputAdornment>
          //   ),
          // }}
        />
        <ShowEsignChangeEmailMessage />
      </Box>
    </SimpleForm>
  );
};

const EsignEdit = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Welcome"
      actions={<Actions />}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<EsignEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default EsignEdit;
